import { useQueryParams } from 'hooks/useQueryParams'
import { useThemeProvider } from 'hooks/useThemeProvider'
import { observer } from 'mobx-react-lite'
import { Helmet } from 'react-helmet'
import { useRootStore } from 'stores/RootStore'

// Wrap this in a component for now to allow access to the query client (used for flipper flag)
export const ThemeProvider = observer(() => {
  useThemeProvider()
  const {
    workspaceTheme,
    handbooks: { currentHandbook },
  } = useRootStore()
  const { focusView } = useQueryParams()
  let theme = workspaceTheme

  const viewingHandbookInFocusMode = focusView && currentHandbook && focusView === currentHandbook.handbook.key

  if (viewingHandbookInFocusMode && currentHandbook.applicableTheme) {
    theme = currentHandbook.applicableTheme
  }

  return (
    <Helmet>
      {(theme.hue || theme.overrides) && (
        <style>
          {`
            html, body {
              --action-50: ${theme.palette['--action-50']};
              --action-60: ${theme.palette['--action-60']};
            }
          `}
        </style>
      )}
    </Helmet>
  )
})
